"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldFetchShareItem = exports.shouldFetchProductBoxes = exports.shouldFetchMedia = exports.remapType = exports.getTag = void 0;
var _models = require("../models");
const getTag = ({
  type,
  categoryId,
  productCode
}) => {
  if (type === 'Category') {
    return categoryId ?? '';
  }
  if (type === 'ProductDetails') {
    return productCode ?? '';
  }
  return '';
};
exports.getTag = getTag;
const shouldFetchMedia = ({
  type,
  categoryId,
  streamId,
  customerId
}) => {
  if (type === 'Category' && categoryId) {
    return true;
  }
  if (type === 'ProductDetails' && streamId) {
    return true;
  }
  if ((type === 'FrontPage' || type === 'Gallery') && customerId) {
    return true;
  }
  return false;
};
exports.shouldFetchMedia = shouldFetchMedia;
const remapType = type => [_models.OlapicTypeEnum.Category, _models.OlapicTypeEnum.FrontPage, _models.OlapicTypeEnum.Gallery, _models.OlapicTypeEnum.ProductDetails][type] ?? _models.OlapicTypeEnum.FrontPage;
exports.remapType = remapType;
const shouldFetchProductBoxes = (productsCodes, loadingSegmentationParameters) => productsCodes.length > 0 && !loadingSegmentationParameters;
exports.shouldFetchProductBoxes = shouldFetchProductBoxes;
const shouldFetchShareItem = (items, shareItemId) => Boolean(shareItemId && items.length > 0 && !items.some(item => item.id === shareItemId));
exports.shouldFetchShareItem = shouldFetchShareItem;
